import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  height: 100vh;
  padding: 1%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const EventsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Event = styled.div`
  width: 30%;
  padding: 1%;
  margin: 1%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(1, 128, 199, 1);
  border-radius: 8px;
  transition: ease-out 0.2s;
  color: #0180C7;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13), 0 1px 1px 0 rgba(0, 0, 0, 0.11);

  .event-time {
    font-size: 0.8em;
    color: rgb(255, 144, 0);
  }

  .event-name {
    margin-bottom: 2%;
  }

  .event-location {
    font-size: 0.8em;
  }
`;

export const Pagination = styled.div`
  display: flex;
  height: 8px;
  width: 10%;
  margin-bottom: 2%;
  justify-content: space-between;
  color: #2a2a2a;
  .arrow {
    &:hover {
      cursor: pointer;
    }
  }
`;

export const CustomLink = styled(Link)`
  text-decoration: none;
  color: #2a2a2a;
  font-size: 1.3em;
  &:hover {
    color: rgb(255, 144, 0);
  }
`;
